import { useLayoutEffect, useState } from 'react';

import browser from '../../browser';

export default function useGetInitialComputedStyle(domElement) {
  const [elementInitialComputedStyle, setElementInitialComputedStyle] = useState({});

  useLayoutEffect(() => {
    if (!domElement) {
      return;
    }

    const elementStyle = browser.window.getComputedStyle(domElement);

    setElementInitialComputedStyle(elementStyle);
  }, [domElement]);

  return elementInitialComputedStyle;
}
